import { render } from "./QuotaCreditTab.vue?vue&type=template&id=3f7d869c&scoped=true"
import script from "./QuotaCreditTab.vue?vue&type=script&lang=js"
export * from "./QuotaCreditTab.vue?vue&type=script&lang=js"

import "./QuotaCreditTab.vue?vue&type=style&index=0&id=3f7d869c&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7d869c"]])

export default __exports__